import { getPartnersLogos } from '../../constants/partnersLogos';

import './Partners.scss';
import { getTranslation } from '../../constants/translations';

export const Partners = () => {
  const partners = getPartnersLogos();
  const t = getTranslation();

  if (partners.length === 0)
    return (
      <section className="main__partners partners partners--empty"></section>
    );

  return (
    <section className="main__partners partners">
      <div className="partners__title title">{t.common.ourPartnerships}</div>
      <div className="_container">
        <div className="partners__container">
          {partners.map((p) => (
            <div key={p} className="partners__logo">
              <img src={`/images/partners/${p}`} alt={p} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
